import {getServerAddress} from "../lib/isBrowser";

const fetchItems = async (endpoint: string, params: string) => {
  const json = await fetch(`${getServerAddress()}/api/${endpoint}?${params}`).then((response) => response.json());
  return Array.isArray(json?.data) ? json.data : [];
};

export default class Autocomplete {
  static async getSuggestions(value: string) {
    try {
      const query = value.toLowerCase().trim().replace(/\s\s+/g, ' ');
      const params = `search=${encodeURIComponent(query)}`;
      // Topics first, then the existing results. A topics failure must not break normal results.
      const [topics, results] = await Promise.all([
        fetchItems('search-topics.json', params).catch(() => []),
        fetchItems('search.json', params),
      ]);
      return [...topics, ...results];
    } catch (e) {
      // Raven.captureException(e);
      return [];
    }
  }
}
